import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import axios from "axios";

let user = JSON.parse(localStorage.getItem("user"));

// API

export const getSpecKontrakKerja = createAsyncThunk(
  "kontrakKerjaTransaksi/getSpecKontrakKerja",
  async ({ TransaksiApprovalID }, thunkAPI) => {
    let formData = new FormData();
    formData.append("TransaksiApprovalID", TransaksiApprovalID);
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "getSpecKontrakKerja",
        formData,
        {
          headers: {
            Authorization: "Bearer " + user.Token,
            Accept: "*/*",
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const getKontrakKerjaTransaksi = createAsyncThunk(
  "kontrakKerjaTransaksi/get",
  async ({ start, count, search }, thunkAPI) => {
    let formData = new FormData();
    formData.append("start", start);
    formData.append("count", count);
    formData.append("search", search);
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "getKontrakKerja",
        formData,
        {
          headers: {
            Authorization: "Bearer " + user.Token,
            Accept: "*/*",
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const insertKontrakKerjaTransaksi = createAsyncThunk(
  "kontrakKerjaTransaksi/insert",
  async (
    { Nik, TipeKaryawanID, NomorKontrak, TanggalMulai, TanggalBerakhir, Keterangan },
    thunkAPI
  ) => {
    let formData = new FormData();
    formData.append("Nik", Nik);
    formData.append("TipeKaryawanID", TipeKaryawanID);
    formData.append("NomorKontrak", NomorKontrak);
    formData.append("TanggalMulai", TanggalMulai);
    formData.append("TanggalBerakhir", TanggalBerakhir);
    formData.append("Keterangan", Keterangan);
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "insertKontrakKerja",
        formData,
        {
          headers: {
            Authorization: "Bearer " + user.Token,
            Accept: "*/*",
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const updateKontrakKerjaTransaksi = createAsyncThunk(
  "kontrakKerjaTransaksi/update",
  async (
    {
      TKontrakKerjaID,
      Nik,
      TipeKaryawanID,
      NomorKontrak,
      TanggalMulai,
      TanggalBerakhir,
      Keterangan,
    },
    thunkAPI
  ) => {
    let formData = new FormData();
    formData.append("TKontrakKerjaID", TKontrakKerjaID);
    formData.append("Nik", Nik);
    formData.append("TipeKaryawanID", TipeKaryawanID);
    formData.append("NomorKontrak", NomorKontrak);
    formData.append("TanggalMulai", TanggalMulai);
    formData.append("TanggalBerakhir", TanggalBerakhir);
    formData.append("Keterangan", Keterangan);
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "updateKontrakKerja",
        formData,
        {
          headers: {
            Authorization: "Bearer " + user.Token,
            Accept: "*/*",
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const deleteKontrakKerjaTransaksi = createAsyncThunk(
  "kontrakKerjaTransaksi/delete",
  async ({ TKontrakKerjaID }, thunkAPI) => {
    let formData = new FormData();
    formData.append("TKontrakKerjaID", TKontrakKerjaID);
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "deleteKontrakKerja",
        formData,
        {
          headers: {
            Authorization: "Bearer " + user.Token,
            Accept: "*/*",
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

//INIT
const initialState = {
  message: "",
  SpecKontrakKerjaData: [],
  isSpecKontrakKerjaFetching: false,
  isSpecKontrakKerjaSuccess: false,
  isSpecKontrakKerjaError: false,
  isGetFetching: false,
  isGetSuccess: false,
  isGetError: false,
  isInsertFetching: false,
  isInsertSuccess: false,
  isInsertError: false,
  isUpdateFetching: false,
  isUpdateSuccess: false,
  isUpdateError: false,
  errorMessage: "",
};

//SLICES
export const kontrakKerjaTransaksiSlice = createSlice({
  name: "kontrakKerjaTransaksi",
  initialState,
  reducers: {},
  extraReducers: {
    // GET
    [getSpecKontrakKerja.fulfilled]: (state, { payload }) => {
      state.SpecKontrakKerjaData = payload.data[0];
      state.isSpecKontrakKerjaSuccess = true;
      state.message = payload.message;
      return state;
    },
    [getSpecKontrakKerja.rejected]: (state, { payload }) => {
      state.isSpecKontrakKerjaFetching = false;
    },
    [getSpecKontrakKerja.pending]: (state) => {
      state.isSpecKontrakKerjaFetching = false;
    },

    [getKontrakKerjaTransaksi.fulfilled]: (state, { payload }) => {
      state.isGetFetching = false;
      state.isGetSuccess = true;
      state.data = payload.data;
      state.count = payload.count;
      state.message = payload.message;
      return state;
    },
    [getKontrakKerjaTransaksi.rejected]: (state, { payload }) => {
      state.isGetFetching = false;
      state.isGetError = true;
      state.errorMessage = payload?.message;
    },
    [getKontrakKerjaTransaksi.pending]: (state) => {
      state.isGetFetching = true;
    },

    // INSERT
    [insertKontrakKerjaTransaksi.fulfilled]: (state, { payload }) => {
      state.isInsertFetching = false;
      state.isInsertSuccess = true;
      state.message = payload.message;
      return state;
    },
    [insertKontrakKerjaTransaksi.rejected]: (state, { payload }) => {
      state.isInsertFetching = false;
      state.isInsertError = true;
      state.errorMessage = payload?.message;
    },
    [insertKontrakKerjaTransaksi.pending]: (state) => {
      state.isInsertFetching = true;
    },

    // UPDATE
    [updateKontrakKerjaTransaksi.fulfilled]: (state, { payload }) => {
      state.isUpdateFetching = false;
      state.isUpdateSuccess = true;
      state.message = payload.message;
      return state;
    },
    [updateKontrakKerjaTransaksi.rejected]: (state, { payload }) => {
      state.isUpdateFetching = false;
      state.isUpdateError = true;
      state.errorMessage = payload?.message;
    },
    [updateKontrakKerjaTransaksi.pending]: (state) => {
      state.isUpdateFetching = true;
    },

    // DELETE
    [deleteKontrakKerjaTransaksi.fulfilled]: (state, { payload }) => {
      state.isUpdateFetching = false;
      state.isUpdateSuccess = true;
      state.message = payload.message;
      return state;
    },
    [deleteKontrakKerjaTransaksi.rejected]: (state, { payload }) => {
      state.isUpdateFetching = false;
      state.isUpdateError = true;
      state.errorMessage = payload?.message;
    },
    [deleteKontrakKerjaTransaksi.pending]: (state) => {
      state.isUpdateFetching = true;
    },
  },
});

export const kontrakKerjaTransaksiSelector = (state) => state.kontrakKerjaTransaksi;
